import React from 'react';
import { Button } from 'antd';
import { UnorderedListOutlined, CalendarOutlined } from '@ant-design/icons';

interface ViewTabsProps {
  currentView: 'list' | 'calendar';
  onViewChange: (view: 'list' | 'calendar') => void;
}

export const ViewTabs: React.FC<ViewTabsProps> = ({
  currentView,
  onViewChange,
}) => {
  return (
    <Button.Group size="middle">
      <Button
        type={currentView === 'list' ? 'primary' : 'default'}
        icon={<UnorderedListOutlined />}
        onClick={() => onViewChange('list')}
        style={{
          backgroundColor: currentView === 'list' ? '#1677ff' : undefined,
          borderColor: currentView === 'list' ? '#1890ff' : undefined,
          color: currentView === 'list' ? '#fff' : undefined,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        List View
      </Button>
      <Button
        type={currentView === 'calendar' ? 'primary' : 'default'}
        icon={<CalendarOutlined />}
        onClick={() => onViewChange('calendar')}
        style={{
          backgroundColor: currentView === 'calendar' ? '#1677ff' : undefined,
          borderColor: currentView === 'calendar' ? '#1890ff' : undefined,
          color: currentView === 'calendar' ? '#fff' : undefined,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        Calendar View
      </Button>
    </Button.Group>
  );
};
